import axios from '@/utils/http.js'
import md5 from 'js-md5'
import api from './index'
// $api

const token = {
    url: {
        // login: "/user/login",
        login: "/user/login",
        thirdlogin: "/user/checkLoginOosServerToken",
        refresh: "/user/refreshToken",
    },
    login: function (form) {
        // const qs = require("qs");
        // form = qs.stringify(form)
        // return axios.post(`${token.url.login}?${form}`)
        return axios.post(`${token.url.login}`,{
            userName:form.userName,
            password:md5(form.password),
            AuthID:form.AuthID,
            isBind:form.isBind
        })
        // let loginXml=`<?xml version="1.0" encoding="UTF-8"?><LoginModel><userName>${form.userName}</userName><passWord>${md5(form.password).toUpperCase()}</passWord></LoginModel>`
        // return axios.post(token.url.login,loginXml,{
        //     headers: {
        //         'Content-Type': 'application/xml'
        //     },
        // })
    },
    thirdlogin: function (form) {
        return axios.post(`${token.url.thirdlogin}`,{token:form.token,screenUrl:form.screenUrl})
    },
    refresh: function (form) {
        return axios.post(token.url.refresh, form)
    },
}

export default token